document.addEventListener("DOMContentLoaded", () => {
  const sectionLogos = document.querySelector(".section-logos");

  // escape hatch
  if (!sectionLogos) return;

  const flipOrder = [1, 3, 0, 4, 2]; // custom flip sequence
  const delay = 3000; // time between flips in milliseconds
  const flipDuration = 600; // CSS flip transition duration in ms (match --flip-duration)

  const pairs = document.querySelectorAll(".logo-flip");

  let step = 0;

  function flipNext() {
    const index = flipOrder[step % flipOrder.length];
    const el = pairs[index];
    el.classList.toggle("flipped");

    step++;
    setTimeout(flipNext, delay);
  }

  setTimeout(flipNext, delay);
});
